<template>
  <div class="spl-header__dotmatrixstatus">
    <div v-if="precarriage_Mode()" class="spl-header__dotmatrixstatus__matrix">
      <div
        v-for="(index, i) in getNumberOfColumns(numberOfNotBooked)"
        :key="'matrixNumberOfNotBooked'+i"
        class="spl-header__dotmatrixstatus__matrix__group">
        <div
          v-for="j in getNumberOfDots(index, numberOfNotBooked)"
          :key="'matrixNumberOfNotBookedDot' + j"
          class="spl-header__dotmatrixstatus__matrix__blue-dot" />
      </div>
      <div
        v-for="(index, i) in getNumberOfColumns(numberOfNotCollected)"
        :key="'matrixNumberOfNotCollected'+i"
        class="spl-header__dotmatrixstatus__matrix__group">
        <div
          v-for="j in getNumberOfDots(index, numberOfNotCollected)"
          :key="'matrixNumberOfNotCollectedDot' + j"
          class="spl-header__dotmatrixstatus__matrix__red-dot" />
      </div>
    </div>
    <div v-if="distribution_Mode()" class="spl-header__dotmatrixstatus__matrix">
      <div
        v-for="(index, i) in getNumberOfColumns(numberOfExternalDelay)"
        :key="'matrixNumberOfExternalDelay'+i"
        class="spl-header__dotmatrixstatus__matrix__group">
        <div
          v-for="j in getNumberOfDots(index, numberOfExternalDelay)"
          :key="'matrixNumberOfExternalDelayDot' + j"
          class="spl-header__dotmatrixstatus__matrix__blue-dot" />
      </div>
      <div
        v-for="(index, i) in getNumberOfColumns(numberOfLate)"
        :key="'matrixNumberOfLate'+i"
        class="spl-header__dotmatrixstatus__matrix__group">
        <div
          v-for="j in getNumberOfDots(index, numberOfLate)"
          :key="'matrixNumberOfLateDot' + j"
          class="spl-header__dotmatrixstatus__matrix__red-dot" />
      </div>
    </div>

    <div v-if="precarriage_Mode()" class="spl-header__dotmatrixstatus__info">
      <div class="spl-header__dotmatrixstatus__info__red" @click="openParcelList(constants.PARCEL_STATUS.NOT_COLLECTED)">
        {{ numberOfNotCollected }} not collected
      </div>
      <div class="spl-header__dotmatrixstatus__info__blue" @click="openParcelList(constants.PARCEL_STATUS.NOT_BOOKED)">
        {{ numberOfNotBooked }} not booked
      </div>
      <div class="spl-header__dotmatrixstatus__info__grey" @click="openParcelList(constants.PARCEL_STATUS.BOOKED_AND_COLLECTED)">
        {{ numberOfCollected }}/{{ numberOfTotal }} collected/total
      </div>
    </div>
    <div v-if="distribution_Mode()" class="spl-header__dotmatrixstatus__info">
      <div class="spl-header__dotmatrixstatus__info__red" @click="openParcelList(constants.PARCEL_STATUS.LATE)">
        {{ numberOfLate }} late
      </div>
      <div class="spl-header__dotmatrixstatus__info__blue" @click="openParcelList(constants.PARCEL_STATUS.EXTERNAL_DELAY)">
        {{ numberOfExternalDelay }} external delay
      </div>
      <div class="spl-header__dotmatrixstatus__info__grey" @click="openParcelList(constants.PARCEL_STATUS.DELIVERED)">
        {{ numberOfDelivered }}/{{ numberOfTotal }} delivered/total
      </div>
    </div>
  </div>
</template>

<script>
import constants from '@/constants'
import moment from 'moment'
export default {
  name: 'Dotmatrixstatus',
  // props: ['notCompleted', 'critical', 'ok', 'total'],
  props: {
    dashboardData: {
      type: Object,
      required: true
    },
    filterSetting: {
      type: Object,
      default: function () {
        return {
          From_Date: '',
          To_Date: '',
          Customers: [],
          Countries: [],
          Parcel_Status: [],
          Service_Levels: [],
          Current_Event_Infos: [],
          Show_Forward_Flow: true
        }
      }
    }
  },
  data () {
    return {
      dotsInColumn: 5,
      viewMode: 'Precarriage',
      constants
    }
  },
  computed: {
    numberOfNotCollected () {
      if (this.dashboardData && this.dashboardData.Not_Collected) {
        return this.dashboardData.Not_Collected
      } else {
        return 0
      }
    },
    numberOfNotBooked () {
      if (this.dashboardData && this.dashboardData.Not_Booked) {
        return this.dashboardData.Not_Booked
      } else {
        return 0
      }
    },
    numberOfCollected () {
      if (this.dashboardData && this.dashboardData.Collected) {
        return this.dashboardData.Collected
      } else {
        return 0
      }
    },

    numberOfLate () {
      if (this.dashboardData && this.dashboardData.Late) {
        return this.dashboardData.Late
      } else {
        return 0
      }
    },
    numberOfExternalDelay () {
      if (this.dashboardData && this.dashboardData.External_Delay) {
        return this.dashboardData.External_Delay
      } else {
        return 0
      }
    },
    numberOfDelivered () {
      if (this.dashboardData && this.dashboardData.Delivered) {
        return this.dashboardData.Delivered
      } else {
        return 0
      }
    },

    numberOfTotal () {
      if (this.dashboardData && this.dashboardData.Total) {
        return this.dashboardData.Total
      } else {
        return 0
      }
    }

  },
  watch: {
    dashboardData: function (newDashboardSummary) {
      // Only show precarriage if it is the same day
      if (moment(this.filterSetting.From_Date).isSame(moment(), 'day')) {
        this.viewMode = 'Precarriage'
      } else {
        this.viewMode = 'Distribution'
      }
      this.dashboardData = newDashboardSummary
    }
  },
  methods: {
    // *********************** Open Pacel List ***********************************
    openParcelList: function (statusId) {
      // Create the filter options needed in the parcel list
      var selectedOptions = {
        from_date: this.filterSetting.From_Date,
        to_date: this.filterSetting.To_Date,
        customer_id: this.filterSetting.Customers,
        country_id: this.filterSetting.Countries,
        tags: this.filterSetting.Tags,
        providers: this.filterSetting.Providers,
        service_level_id: this.filterSetting.Service_Levels,
        status: statusId,
        current_event_infos: this.filterSetting.Current_Event_Infos,
        show_forward_flow: this.filterSetting.Show_Forward_Flow,
        from_postal_code: this.filterSetting.From_Postal_Code,
        to_postal_code: this.filterSetting.To_Postal_Code
      }
      this.$router.replace({ name: 'parcel-list', params: selectedOptions })
    },

    getNumberOfDots (i, dots) {
      if (i * this.dotsInColumn > dots) {
        return dots % this.dotsInColumn
      } else {
        return this.dotsInColumn
      }
    },
    /// Calculate the number of columns needed (we set max 25 columns in order to not get too wide)
    getNumberOfColumns (dots) {
      if (this.dotsInColumn > 0) {
        return Math.min(Math.ceil(dots / this.dotsInColumn), 25)
      } else {
        return 0
      }
    },
    precarriage_Mode () {
      if (!this.viewMode) return true
      return this.viewMode === 'Precarriage'
    },
    distribution_Mode () {
      if (!this.viewMode) return false
      return this.viewMode === 'Distribution'
    }
  }
}
</script>

<style lang="scss">
    @import '../../variables.scss';

    .spl-header__dotmatrixstatus {
        float: right;
        height: $headerHeight;
        padding: 15px 30px 0 15px;

        @media screen and (max-width: 1400px) {
          display: none
        }

        &__matrix {
            display: inline-block;
            vertical-align: top;

            &:after {
                clear: both;
                content: '';
                display: block;
                float: none;
            }
            &__group {
                float: right;
            }
            &__red-dot,
            &__blue-dot {
                background-color: $red;
                border-radius: 50%;
                height: 2px;
                margin: 5px 5px 0 0;
                width: 2px;
            }
            &__blue-dot {
                background-color: $blue;
            }
        }
        &__info {
            display: inline-block;
            margin: 2px 0 0 10px;
            vertical-align: top;

            &__red,
            &__blue,
            &__grey {
                font-family: $mono;
                font-size: 9px;
                font-weight: 700;
                text-transform: uppercase;
                line-height: 12px;
                letter-spacing: 1px;
            }
            &__red {
                color: $red;
            }
            &__blue {
                color: $blue;
            }
            &__grey {
                color: $grey;
            }
        }
    }
</style>
